const hemType = {
  australia_wide: "Australia Wide",
  geographic_location: "By Geographic Location",
  australia_wide_income: "Australia Wide, Income Adjusted",
  geographic_income: "By Geographic Location, Income Adjusted"
}

const state = {
  status: true,
  commercial: true,
  hemBy: {
    label: hemType[Ambition.getGlobal("tenant.hem_option")],
    value: Ambition.getGlobal("tenant.hem_option")
  },
  note: null,
  applicantStatus: [false]
}

const getters = {
  status: state => {
    return state.status
  },
  applicantStatus: state => {
    return state.applicantStatus
  },
  commercial: state => {
    return state.commercial
  },
  hemBy: state => {
    return state.hemBy
  },
  note: state => {
    return state.note
  }
}

const mutations = {
  setStatus(state, status) {
    state.status = status
  },
  setCommercial(state, commercial) {
    state.commercial = commercial
  },
  setNote(state, note) {
    state.note = note
  },
  setApplicantStatus(state, status) {
    state.applicantStatus = status
  }
}

const actions = {
  setStatus(context, status) {
    context.commit("setStatus", status)
  },
  setApplicantStatus(context, status) {
    context.commit("setApplicantStatus", status)
  },
  setCommercial(context, commercial) {
    context.commit("setCommercial", commercial)
  },
  setNote(context, note) {
    context.commit("setNote", note)
  },
  setValidating(context, validating) {
    context.commit("setValidating", validating)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
